import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SchedulerSettingsComponent } from './components/scheduler-settings/scheduler-settings.component';
import { SchedulerRoutingModule } from './scheduler-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SchedulerSettingsService, schedulerSettingsServiceFactory } from './services/scheduler-settings.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService, SharedModule } from 'src/app/shared';
import { SchedulerStatusComponent } from './components/scheduler-status/scheduler-status.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { SettingsButtonComponent } from './components/settings-button/settings-button.component';
import { ApplicationSettingsComponent } from './components/application-settings/application-settings.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ThreadsSchedulerSettingsComponent } from './components/threads-scheduler-settings/threads-scheduler-settings.component';
import { ThreadsSchedulerSettingsFormComponent } from './components/threads-scheduler-settings-form/threads-scheduler-settings-form.component';
import { StuckTreadsCheckerSettingsComponent } from './components/stuck-treads-checker-settings/stuck-treads-checker-settings.component';
import { StuckTreadsCheckerSettingsFormComponent } from './components/stuck-treads-checker-settings-form/stuck-treads-checker-settings-form.component';
import { GarbageCollectorShedulerSettingsComponent } from './components/garbage-collector-sheduler-settings/garbage-collector-sheduler-settings.component';
import { GarbageCollectorShedulerSettingsFormComponent } from './components/garbage-collector-sheduler-settings-form/garbage-collector-sheduler-settings-form.component';

@NgModule({
    declarations: [
        SchedulerSettingsComponent,
        SchedulerStatusComponent,
        SettingsButtonComponent,
        ApplicationSettingsComponent,
        ThreadsSchedulerSettingsComponent,
        ThreadsSchedulerSettingsFormComponent,
        StuckTreadsCheckerSettingsComponent,
        StuckTreadsCheckerSettingsFormComponent,
        GarbageCollectorShedulerSettingsComponent,
        GarbageCollectorShedulerSettingsFormComponent
    ],
    providers: [
        {
            provide: SchedulerSettingsService,
            useFactory: schedulerSettingsServiceFactory,
            deps: [HttpClient, AuthenticationService]
        },
        DecimalPipe
    ],
    imports: [
        CommonModule,
        SchedulerRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatButtonModule,
        SharedModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatDialogModule,
        MatGridListModule,
        MatTabsModule
    ],
    exports: [SchedulerSettingsComponent, SchedulerStatusComponent, SettingsButtonComponent]
})
export class SchedulerModule {}
